import { useTheme } from '@mui/material';
import { generateCompanyLogoUrlDirect } from '@sharedInterfaces/globalEnums';
import type { AppState } from '@store/store';
import { useSelector } from 'react-redux';

/**
 * Hook to generate company logo URL with automatic theme detection
 */
export function useCompanyLogoUrl(size: number = 100): string {
    const theme = useTheme();
    const companyId = useSelector((state: AppState) => state.company.companyId);
    const logoIdLight = useSelector((state: AppState) => state.company.style.logoIdLight);
    const logoIdDark = useSelector((state: AppState) => state.company.style.logoIdDark);

    const isDarkMode = theme.palette.mode === 'dark';

    return generateCompanyLogoUrlDirect(companyId, logoIdLight, logoIdDark, size, isDarkMode);
}
